module.exports = __webpack_public_path__ + "static/media/ajuda.b10e9635.svg";